// extracted by mini-css-extract-plugin
module.exports = {"rightSidebar":"Notifications_rightSidebar__27_GJ","content":"Notifications_content__2qZ7R"};